<ng-container *ngFor="let item of localErrorMessages">
  <span *ngIf="item.isValid"
     class="material-icons show-error-info"
     matTooltip="{{item.message.replace(regex, fieldName)}}"
     matTooltipPosition="{{position}}">
    error
  </span>
</ng-container>
